export enum VariableScope {
  session = 'session',
  conversation = 'conversation'
}
